import SaaNew from "components/pages/saa/New";
import { GetServerSidePropsContext } from "next";
import { NextPage } from "next";

interface Props {
  isMobile: boolean;
}

const SaaNewPage: NextPage<Props> = ({ isMobile }) => {
  return <SaaNew isMobile={isMobile} />;
};
export default SaaNewPage;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  // const { req, res } = context;

  // const cookieHeader = req.headers.cookie || "";
  // const cookies = cookieHeader
  //   ? Object.fromEntries(
  //       cookieHeader
  //         .split("; ")
  //         .filter(Boolean)
  //         .map((c) => {
  //           const idx = c.indexOf("=");
  //           const k = decodeURIComponent(c.slice(0, idx));
  //           const v = decodeURIComponent(c.slice(idx + 1));
  //           return [k, v];
  //         })
  //     )
  //   : ({} as Record<string, string>);

  // const existing = cookies["rw_ab_saa"];
  // const hasValid = existing === "a" || existing === "b";
  // if (!hasValid) {
  //   const chosen = Math.random() < 0.5 ? "a" : "b";
  //   const maxAge = 60 * 24 * 60 * 60; // 60일(초)
  //   const cookie = `rw_ab_saa=${chosen}; Path=/; Max-Age=${maxAge}; SameSite=Lax`;

  //   const prev = res.getHeader("Set-Cookie");
  //   let updated: string[];
  //   if (Array.isArray(prev)) {
  //     updated = [...prev, cookie];
  //   } else if (typeof prev === "string") {
  //     updated = [prev, cookie];
  //   } else {
  //     updated = [cookie];
  //   }
  //   res.setHeader("Set-Cookie", updated);
  // }

  return {
    props: {
      hasMetaData: true,
    },
  };
}
